import { Fragment } from 'react'
import { messageHasEmoji, splitMessageByEmoji } from '@/utils/messageEmojiText'
import styles from '../UserChatBubble/index.module.scss'

export function renderTextChunk(chunk, keyPrefix) {
  if (!chunk) return null
  if (!messageHasEmoji(chunk)) {
    return <Fragment key={keyPrefix}>{chunk}</Fragment>
  }

  return splitMessageByEmoji(chunk).map((segment, index) =>
    segment.type === 'emoji' ? (
      <span key={`${keyPrefix}-emoji-${index}`} className={styles.emojiInline}>
        {segment.value}
      </span>
    ) : (
      <Fragment key={`${keyPrefix}-text-${index}`}>{segment.value}</Fragment>
    ),
  )
}
